import ServiceBus from "servicestack/service-bus";
import basicController from "servicestack/basic.controller.properties";
import cartConfig from "emun.cart/cart.config";
import AutoQuery from "servicestack/auto-query/auto-query";
import orderConfig from "emun.order/order.config";
import _ from "underscore";
import modals from 'webmodals/modals'

export default class TicketPromptController {
    constructor(options) {
        const $ctrl = this;
        basicController($ctrl);
        $ctrl.bus = new ServiceBus();
        $ctrl.ticket = Object.assign({}, options.model, options.ticket);
        $ctrl.title = options.title || "Ticket Info";
    }
    $onInit() {
        const $ctrl = this;
		$ctrl.bus
		  .send("GetTicketFields.json")
		  .then(function(res) {
			$ctrl.ticketFields = _.indexBy(res.data.ticket_fields, 'title'); 
		  });
    }
	updateTicket() {
		const $ctrl = this;
		$ctrl.ticket.CustomFields = $ctrl.ticket.custom_fields;

		//if($ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('Country')].value == "US" && !$ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('State')].value) {
		//	$ctrl.bus.validationErrors = [];
		//	$ctrl.bus.validationErrors.push([{
		//		errorCode: "-1",
		//		fieldName: "address",
		//		message: "State must be populated"
		//	}]);
		//	return;
		//}

		//if($ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('Country')].value == "US" && !$ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('Zip')].value) {
		//	$ctrl.bus.validationErrors = [];
		//	$ctrl.bus.validationErrors.push([{
		//		errorCode: "-1",
		//		fieldName: "address",
		//		message: "Zip must be populated"
		//	}]);
		//	return;
		//}

		$ctrl.bus.send('UpdateTicket.json', $ctrl.ticket).then(function(res) {
			$ctrl.fillOrderFromTicket();
			$ctrl.bus.send('UpdateCart.json', $ctrl.$cart).then(function(res) {
				$ctrl.$dismiss();
			});
		}, function(res) {
			modals.alert(res.data.responseStatus.message);
		});
	}

	fillOrderFromTicket() {
		const $ctrl = this;
		$ctrl.$cart.tagFor = $ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('Fan Model # (Primary)')].value
		$ctrl.$cart.purchaser.email = $ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('Email')].value;
		$ctrl.$cart.shippingLocation = {
			companyName: $ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('Customer Name')].value,
			address: $ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('Address')].value,
			city: $ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('City')].value,
			state: $ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('State')].value,
			zip: $ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('Zip')].value,
			country: $ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('Country')].value,
			phone: $ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('Phone')].value,
			email: $ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('Email')].value
		};
	}
	getFieldByTitle(title) {
		const $ctrl = this;
		var index = $ctrl.getFieldIndex($ctrl.ticketFields[title].id);
		return index;
	}
	getFieldIndex(id) {
		const $ctrl = this;
		var fieldIndex = -1;
		$ctrl.ticket.custom_fields.forEach(function(c, index) {
			if (c.id == id) {
				fieldIndex = index;
			}
		});
		return fieldIndex;
	}
}
